<template>
  <v-container>
    <img
      @click="$emit('closeDialog')"
      class="close-btn"
      src="../../assets/icons/close.png"
      alt="Close"
    />
    <v-form v-model="valid" class="clearAfterFloats">
      <v-flex xs12 text-xs-center>
        <h1 class="header-text">
          <span>
            Upravljanje korisnicima
            <div class="header-text-line"></div>
          </span>
        </h1>
      </v-flex>
      <div class="form-part">
        <v-flex xs12>
          <v-text-field
            v-model="user.FirstName"
            :rules="rules.required"
            label="Ime"
            @blur="setUsername"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-text-field
            v-model="user.LastName"
            :rules="rules.required"
            label="Prezime"
            @blur="setUsername"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-text-field v-model="user.Username" :rules="rules.required" label="Korisničko ime"></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-text-field v-model="user.Email" label="Email"></v-text-field>
        </v-flex>
        <div v-if="!isUpdate">
          <v-flex xs12>
            <v-text-field v-model="user.Password" :rules="rules.required" label="Lozinka"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn @click="generatePassword">Generiraj lozinku</v-btn>
          </v-flex>
        </div>
        <v-flex xs12 v-if="isUpdate">
          <v-btn @click="resetPassword">Resetiraj lozinku</v-btn>
        </v-flex>
      </div>
      <div class="form-part">
        <v-flex xs12>
          <v-text-field v-model="user.Phone" label="Broj telefona"></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-text-field v-model="user.City" label="Grad"></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-select
            v-model="user.UserRoles"
            :rules="rules.select"
            :items="roles"
            class="dropdown-users"
            label="Korisničke uloge"
            item-value="RoleId"
            item-text="Name"
            chips
            multiple
          ></v-select>
        </v-flex>

        <v-flex xs12>
          <v-select
            v-model="user.UserInstruments"
            :items="instruments"
            class="dropdown-users"
            label="Instrumenti"
            item-value="InstrumentId"
            item-text="Name"
            chips
            multiple
          ></v-select>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs5>
            <v-checkbox label="Aktivan" v-model="user.IsActive"></v-checkbox>
          </v-flex>
          <v-flex xs7 class="text-right">
            <v-btn class="main-btn" :disabled="!valid" v-if="!isUpdate" @click="postUser">Kreiraj</v-btn>
            <v-btn class="main-btn" :disabled="!valid" v-else @click="updateUser">Uredi</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-form>
  </v-container>
</template>

<script>
export default {
  props: ["isUpdate", "isModalOpen", "userId"],
  data() {
    return {
      user: {
        IsActive: true,
        Password: "",
        Username: ""
      },
      valid: false,
      rules: {
        required: [v => !!v || "Polje je obavezno"],
        select: [v => v.length > 0 || "Polje je obavezno"]
      },
      //For v-select
      roles: [],
      instruments: []
    };
  },
  methods: {
    getUser() {
      this.$store.state.services.userService.get(this.userId).then(response => {
        this.user = response.data;
      });
    },
    getRoles() {
      this.$store.state.services.roleService.getAll().then(response => {
        this.roles = response.data;
      });
    },
    getInstruments() {
      this.$store.state.services.instrumentService.getAll().then(response => {
        this.instruments = response.data;
      });
    },
    postUser() {
      this.formatRolesAndInstruments();
      this.$store.state.services.userService.add(this.user).then(response => {
        this.userChangedOrAdded(response.data);
      });
    },
    updateUser() {
      this.formatRolesAndInstruments();
      this.$store.state.services.userService
        .update(this.user)
        .then(response => {
          this.userChangedOrAdded(response.data);
        });
    },
    //Preparing data for .net core data binding
    formatRolesAndInstruments() {
      var userRoles = this.user.UserRoles;
      var userInstruments = this.user.UserInstruments;
      this.user.UserRoles = [];
      this.user.UserInstruments = [];
      userRoles.forEach(roleId => {
        this.user.UserRoles.push({ RoleId: roleId });
      });
      if (userInstruments && userInstruments.length > 0) {
        userInstruments.forEach(instrumentId => {
          this.user.UserInstruments.push({
            InstrumentId: instrumentId
          });
        });
      }
    },
    generatePassword() {
      this.user.Password = Math.random()
        .toString(36)
        .substr(2, 8);
    },
    resetPassword() {
      if (confirm("Da li ste sigurni da zelite resetovati lozinku?")) {
        this.$store.state.services.userService
          .resetPassword(this.user.UserId)
          .then(res => {
            this.userChangedOrAdded(res.data);
          });
      }
    },
    userChangedOrAdded(response) {
      this.$emit("userChangedOrAdded", response);
    },
    resetUserToDefaults() {
      this.user = {
        IsActive: true,
        Password: "",
        FirstName: "",
        LastName: "",
        Username: ""
      };
    },
    setUsername() {
      if (this.user.FirstName && this.user.LastName) {
        this.user.Username =
          this.user.FirstName.toLowerCase() +
          "." +
          this.user.LastName.toLowerCase();
      }
    }
  },
  created() {
    this.getRoles();
    this.getInstruments();
  },
  watch: {
    isModalOpen() {
      if (this.isModalOpen == false) {
        this.resetUserToDefaults();
      } else if (this.isUpdate == true) {
        this.getUser();
      }
    }
  }
};
</script>
<style scoped>
.form-part {
  width: 50%;
  float: left;
  padding: 10px 15px;
}
.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 35px;
  cursor: pointer;
}
.dropdown-users {
  margin: 0;
}
/* .dropdown-users /deep/ .v-input__slot{
  margin: 0!important;
} */
</style>
